import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import {
  GetParticipantsByStatusResponse,
  PrintLabelsResponse,
  GraphQlError,
  GetListConfirmedOrdersResponse,
  GetListSequencersResponse,
} from '../../core/types/common.types';

export const getParticipantsByStatusThunk = createAsyncThunk<
  // Return type of the payload creator
  GetParticipantsByStatusResponse,
  // First argument to the payload creator
  string,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('print/getParticipantsByStatusThunk', async (status, thunkApi) => {
  const response: GetParticipantsByStatusResponse = await portalApi.getParticipantsByStatus(status);

  if (response.errors) {
    return thunkApi.rejectWithValue(response.errors);
  }
  return response.data?.getParticipantsByStatus as GetParticipantsByStatusResponse;
});

export const getListConfirmedOrdersThunk = createAsyncThunk<
  // Return type of the payload creator
  GetListConfirmedOrdersResponse,
  // First argument to the payload creator
  string,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('print/getListConfirmedOrdersThunk', async (filterTerm, thunkApi) => {
  const response: GetListConfirmedOrdersResponse = await portalApi.getListConfirmedOrders(filterTerm);

  if (response.errors) {
    return thunkApi.rejectWithValue(response.errors);
  }
  return response.data?.listConfirmedOrders as GetListConfirmedOrdersResponse;
});

export const getListSequencersThunk = createAsyncThunk<
  GetListSequencersResponse,
  string,
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('print/getListSequencersThunk', async (values, thunkApi) => {
  const response: GetListSequencersResponse = await portalApi.getListSequencersQuery();

  if (response.errors) {
    return thunkApi.rejectWithValue(response.errors);
  }
  return response.data?.listSequencers as GetListSequencersResponse;
});

export const printLabelsThunk = createAsyncThunk<
  // Return type of the payload creator
  PrintLabelsResponse,
  // First argument to the payload creator
  string[],
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('print/printLabels', async (values, thunkApi) => {
  const response: PrintLabelsResponse = await portalApi.printLabels(values);

  if (response.errors) {
    return thunkApi.rejectWithValue(response.errors);
  }
  return response.data?.printLabels as PrintLabelsResponse;
});
